import { useKeycloak } from '@react-keycloak/web';
import React, { useEffect } from 'react';
import ReactModal from 'react-modal';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import LoginPage from '../pages/Login';
import RegisterPage from '../pages/Register';
import AppRouter from './AppRouter';
import { ROUTES } from './routes';
import { PrivateRoute } from './utils';
import PublicInvoiceGenerator from '../pages/Public/PublicInvoiceGenerator';
import { ToastProvider } from 'react-toast-notifications';

export const DefaultRouter = () => {
    ReactModal.setAppElement('#root');
    const { keycloak, initialized } = useKeycloak();
    useEffect(() => {
        if (!keycloak || !initialized) {
            return;
        }

        if (keycloak.tokenParsed) {
            window.heap.identify((keycloak.tokenParsed as any).email);
        }
    }, [keycloak, initialized]);
    return (
        <ToastProvider autoDismiss>
            <Router>
                <Route exact path={ROUTES.LOGIN} component={LoginPage} />
                <Route exact path={ROUTES.REGISTER} component={RegisterPage} />
                <Route exact path={ROUTES.PUBLIC_INVOICE_GENERATOR} component={PublicInvoiceGenerator} />
                <PrivateRoute exact path={ROUTES.CONNECT_STRIPE} component={AppRouter} />
                <PrivateRoute path={ROUTES.DASHBOARD} component={AppRouter} />
                <Route exact path="/" render={() => <Redirect to={ROUTES.DASHBOARD} />} />
            </Router>
        </ToastProvider>
    );
};
